var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isPasswordResetRequest)?_c('cmg-password-reset-request-form',{on:{"reset-request-event":_vm.onSuccessfulResetRequest}}):_c('cmg-password-reset-request-complete',{attrs:{"email":_vm.email},on:{"retry-password-reset":_vm.onRetryPasswordReset}})
}
var staticRenderFns = []

export { render, staticRenderFns }